import { BaseService } from "./BaseService";
import { Measures } from "../types/app.interfaces";
import { FunctionGroup } from "../types/app.enums";

export class BenchmarkRankService extends BaseService {
  burgissCalcPooledRankingIRR(
    investId?: any[][],
    idType?: string,
    beginDate?: any,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "IRR",
        investId,
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingIRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "IRR",
        [],
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingIRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "IRR",
        [],
        investId,
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingIRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    return null;
  }

  burgissCalcPooledRankingTWRR(
    investId?: any[][],
    idType?: string,
    beginDate?: any,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string,
    dynamicParameter?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "TWRR",
        investId,
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        dynamicParameter
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTWRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "TWRR",
        [],
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        dynamicParameter
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTWRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        beginDate,
        idType,
        selectionSetId,
        filter,
        "TWRR",
        [],
        investId,
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        dynamicParameter
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTWRR",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    return null;
  }

  burgissCalcPooledRankingDPI(
    investId?: any,
    endDate?: any,
    currency?: string,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "DPI",
        investId,
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingDPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "DPI",
        [],
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingDPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "DPI",
        [],
        investId,
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingDPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    return null;
  }

  burgissCalcPooledRankingRVPI(
    investId?: any,
    idType?: string,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "RVPI",
        investId,
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingRVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "RVPI",
        [],
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingRVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "RVPI",
        [],
        investId,
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingRVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    return null;
  }

  burgissCalcPooledRankingTVPI(
    investId?: any[][],
    idType?: string,
    endDate?: any,
    currency?: string,
    selectionSetId?: any,
    filter?: any,
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    alternatebasecurrrency?: string,
    uniqueCellId?: string
  ) {
    if (idType == "p") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "TVPI",
        investId,
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "i") {
      const objRequest = this.createPayload(
        investId,
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "TVPI",
        [],
        [],
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    if (idType == "a") {
      const objRequest = this.createPayload(
        [],
        endDate,
        currency,
        null,
        null,
        idType,
        selectionSetId,
        filter,
        "TVPI",
        [],
        investId,
        sampleStatistic,
        rankValue,
        numSimulations,
        desiredSampleSize,
        requirReportedValuation,
        stopOn,
        null,
        alternatebasecurrrency,
        uniqueCellId,
        null
      );
      return super._pushOperation(
        "BurgissCalcPooledRankingTVPI",
        objRequest,
        this.APICONFIG.GETPORTFOLIORANKING,
        FunctionGroup.BenchmarkRank
      );
    }
    return null;
  }

  createPayload(
    investId?: any[][],
    endDate?: any,
    currency?: string,
    rollForward?: string,
    beginDate?: any,
    idType?: string,
    selectionSetId?: any,
    filter?: any,
    measure?: string,
    portfolioId?: any[][],
    assetId?: any[][],
    sampleStatistic?: any,
    rankValue?: any,
    numSimulations?: any,
    desiredSampleSize?: any,
    requirReportedValuation?: any,
    stopOn?: any,
    maxAge: any = null,
    alternateCurrrency: string = null,
    alias: string = null,
    dynamicParameter: any = null
  ) {
    const measuresObject: Measures = {
      excludeRealizationsPriorToClosingDate: null,
      financeIndexID: null,
      financePremium: null,
      reinvestmentIndexID: null,
      reinvestmentPremium: null,
      forceRollForward: null,
      peergroupID: null,
      percentile: null,
      currency: null,
      isHoldingCalc: false,
      alternateBaseCurrency: alternateCurrrency,
      year: null,
      indexID: null,
      premium: null,
      weightingMethod: null,
      value: null,
      attributeName: null,
      maxAgeDiffYears: maxAge,
      horizon: null,
      maxDroppedPeriods: null,
      lastHistoricalEOQDate: null,
      minSampleSize: null,
      sampleStatistic: sampleStatistic,
      currencyHedgesetId: "",
      dynamicParameter: dynamicParameter == "" ? null : dynamicParameter,
      universe: null,
      weight: null,
      commitment: null,
      investmentID: String(investId).toUpperCase() == "ALL" ? "-1" : String(investId),
      baseCurrency: Boolean(currency),
      adjustToMostRecent: Boolean(rollForward),
      measure: measure,
      filter: filter,
      endDate: endDate,
      idType: idType,
      beginDate: beginDate,
      portfolioID: String(portfolioId).toUpperCase() == "ALL" ? "-1" : String(portfolioId),
      alias: alias,
      bMUHistoricalWindowLengthQtrs: 0,
      desiredSampleSize: desiredSampleSize, //5,
      excludeBalanceSheetItems: false,
      excludeFrozenAsset: true,
      excludeUndisclosedItems: false,
      excludeUnknownEntities: false,
      fofLookThrough: false,
      requireReportedValuation: requirReportedValuation,
      returnConstituentCount: false,
      returnPooledResult: true,
      selectionsetID: selectionSetId, //"0",
      stopOn: stopOn,
      useAlternateFundSize: false,
      useReceivedDate: false,
      assetID: String(assetId).toUpperCase() == "ALL" ? "-1" : String(assetId),
      rankValue: rankValue,
      numSimulations: numSimulations,
    };
    return measuresObject;
  }
}
